import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';

export const AutomaticWithdrawalsWrapper = styled('div', { label: 'AutomaticWithdrawalsWrapper' })`
   background-color: ${mainColors.default.light};
   flex: 1 1 0%;
   height: calc(100vh - 56px);
   overflow: hidden;
   padding: 0 24px;
`;

export const HeaderSection = styled('div', { label: 'HeaderSection' })`
    border-bottom: 1px solid ${mainColors.grays.gray200};
    display: flex;
    height: 47px;
    position: relative;
`;

export const SwitcherWrapper = styled('div', { label: 'SwitcherWrapper' })`
    display: flex;
    flex: 0 1 auto;
    justify-content: center;
    margin-right: 8px;
    position: relative;
`;

export const SelectedTabFilterItem = styled('button', { label: 'SelectedTabFilterItem' }) <{ isActive: boolean }>`
    background: transparent;
    border: none;
    border-bottom: 3px solid ${({ isActive }): string => isActive ? mainColors.main.secondary : 'transparent'};
    cursor: pointer;
    font-size: 14px;
    margin: 0 8px;
    outline: none;
    text-shadow: 0px 0px 1px ${({ isActive }): string => isActive ? '#000' : '#fff'};
    width: 88px;
`;

export const SelectedTabFilterWrapper = styled('div', { label: 'SelectedTabFilterWrapper' })`
    bottom: 0;
    display: flex;
    left: calc(50% - 100px);
    position: absolute;
`;

export const MainContent = styled('div', { label: 'MainContent' })`
    width: 100%;
    height: auto;
    padding-top: 20px;
`;
